const TEXT_MODE = 0;
const TAGNAME_MODE = 1;
const ATTRIBUTE_MODE = 2;
// const ATTRIBUTE_VALUE_MODE = 3;

// const attributeStartRegex = /([ \x09\x0a\x0c\x0d])([^\0-\x1F\x7F-\x9F
// "'>=/]+)/;

export const buildTemplate = (strings: string[]) => {
  const l = strings.length - 1;
  const html = '';

  let mode = TEXT_MODE;

  for (let i = 0; i < l; i++) {
    const s = strings[i];
    for (let j = 0; j < s.length; j++) {
      const c = s[j];
      switch (mode) {
        case TEXT_MODE:
          if (c === '<') {
            mode = TAGNAME_MODE;
          }
          break;
        case TAGNAME_MODE:
          if (c === '!') {
            // maybe comment open
          } else if (c === ' ' || c === '\t' || c === '\n') {
            mode = ATTRIBUTE_MODE;
          }
          break;
        case ATTRIBUTE_MODE:
          // if
          console.log('attribute');
          break;
      }
    }
  }
  return html;
};
